import {
  Box,
  Button,
  ContentLayout,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import ActiveOrderStatus, { useActiveOrders } from '../../components/ActiveOrders';
import useOrderFilter from '../../hooks/use-orderFilter';

function ActiveOrdersPage() {
  const navigate = useNavigate();
  const { orderType, FilterButtons } = useOrderFilter();
  const activeOrders = useActiveOrders(999, orderType);

  return (
    <ContentLayout
      header={(
        <Header
          actions={(
            <Button variant="normal" onClick={() => { navigate('/orders/shipped'); }}>See shipped orders</Button>
          )}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div>Active Orders</div>
            <FilterButtons />
          </div>
        </Header>
      )}
    >
      <SpaceBetween direction="vertical" size="l">
        {activeOrders?.length ? (
          activeOrders.map((order) => (
            <ActiveOrderStatus
              key={order.lineItemId || order.projectNumber}
              lineItemId={order.lineItemId || order.projectNumber}
              organization={order.organization}
              projectNumber={order.projectNumber}
              projectId={order.projectId}
              projectDocId={order.projectDocId}
              shipDate={order.shipDate}
              steps={order.steps}
              notes={order.notes}
            />
          ))
        ) : (
          <Box
            margin={{ vertical: 'm' }}
            textAlign="center"
            color="inherit"
          >
            <b>No orders</b>
          </Box>
        )}
      </SpaceBetween>
    </ContentLayout>
  );
}

export default ActiveOrdersPage;
